/**
 * Auroma Bundle Picker
 * File: assets/auroma-bundle-picker.js
 *
 * Auto-detects slot count — works for ×3, ×4, ×5, ×6, ×8, ×16, etc.
 * Fragrances read live from Simple Bundles selects on every page load.
 *
 * Installation:
 *   1. Upload to Assets in your Shopify theme.
 *   2. Add before </body> in layout/theme.liquid:
 *        <script src="{{ 'auroma-bundle-picker.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  // ── Merchandising lists ────────────────────────────────────────────────────
  // Update these arrays whenever your range changes.
  // Values must match the start of the fragrance name exactly as it appears
  // in Simple Bundles (i.e. the part before " - Smells Like").

  var NEW_FRAGRANCES = [
    'Galactic Bloom',
    'Celestial Choice',
    'Your Stellar Self 59',
    'Galactic Rise',
    'Galactic Flora Glowing Orchid',
    'Moonlit Boreal Legend',
    'Meteor Jacobs Pinnacle',
    'Icarus Mist For Her',
    'Astra Di Galaxy',
    'Parallaxme',
    'Voyager Born In Orbit',
    'Meteor Boreal Legend',
    'Boreal Touch For Men',
  ];

  var BESTSELLER_FRAGRANCES = [
    'Astronus 10',
    'Lunar Cherry 23',
    'Spectrum 90',
    'Celestial Red 10',
    'Void Eclipse 25',
    'Fornax 60',
    'Borealis 20',
    'Virgo Orbital 25',
    'Celestial Allure 31',
    'Imperian 3',
    'Astra 11',
    'Perseid 06',
    'Noir Obsidian 45',
    'Astro Mist Way 13',
  ];
  // ─────────────────────────────────────────────────────────────────────────

  function init() {
    const container = document.getElementById('simple-bundles-io-options');
    if (!container) return;
    if (!document.getElementById('fragrance-1')) { setTimeout(init, 300); return; }

    let N = 0;
    while (document.getElementById(`fragrance-${N + 1}`)) N++;
    if (N === 0) return;

    injectStyles();
    hideNativeUI(container);
    buildUI(container, N);
  }

  function injectStyles() {
    if (document.getElementById('ab-styles')) return;
    const s = document.createElement('style');
    s.id = 'ab-styles';
    s.textContent = `
      #simple-bundles-io-options label,
      #simple-bundles-io-options select { display: none !important; }

      .ab-wrap * { box-sizing: border-box; }
      .ab-sr-only {
        position: absolute; width: 1px; height: 1px;
        padding: 0; margin: -1px; overflow: hidden;
        clip: rect(0,0,0,0); white-space: nowrap; border: 0;
      }
      .ab-wrap { font-family: 'Poppins', sans-serif; margin: 12px 0; }

      /* ── Slot rows ── */
      .ab-slots { display: flex; flex-direction: column; gap: 7px; margin-bottom: 10px; }
      .ab-slot {
        display: flex; align-items: center; gap: 10px;
        border: 1.5px solid #e8e8e8; border-radius: 8px;
        padding: 10px 12px; cursor: pointer; background: #fff;
        transition: border-color .18s; user-select: none;
      }
      .ab-slot:hover  { border-color: #f4a623; }
      .ab-slot.filled { border-color: #f4a623; background: #fffcf5; }
      .ab-slot-num {
        width: 22px; height: 22px; border-radius: 50%;
        background: #f4a623; color: #111; font-size: 11px; font-weight: 700;
        display: flex; align-items: center; justify-content: center; flex-shrink: 0;
      }
      .ab-slot-lbl { font-size: 13px; color: #767676; flex: 1; }
      .ab-slot.filled .ab-slot-lbl { color: #111; font-weight: 500; }
      .ab-slot-x {
        font-size: 18px; color: #ccc; display: none;
        line-height: 1; padding: 2px 0; transition: color .12s;
        background: none; border: none; cursor: pointer; font-family: inherit;
      }
      .ab-slot.filled .ab-slot-x { display: block; }
      .ab-slot-x:hover { color: #e53e3e; }

      /* ── Trigger button ── */
      .ab-open-btn {
        width: 100%; padding: 12px 16px; background: #111; color: #fff;
        border: none; border-radius: 8px; font-family: 'Poppins', sans-serif;
        font-size: 13px; font-weight: 600; letter-spacing: .03em;
        cursor: pointer; display: flex; align-items: center;
        justify-content: center; gap: 8px; transition: background .18s;
      }
      .ab-open-btn:hover { background: #333; }
      .ab-badge {
        background: #f4a623; color: #111; border-radius: 20px;
        padding: 1px 7px; font-size: 11px; font-weight: 700;
      }

      /* ── Overlay ── */
      .ab-overlay {
        display: none; position: fixed; inset: 0;
        background: rgba(0,0,0,.45);
        z-index: 100000; align-items: flex-end; justify-content: center;
      }
      .ab-overlay.open { display: flex; }
      @media (min-width: 640px) { .ab-overlay { align-items: center; } }

      /* ── Modal shell ── */
      .ab-modal {
        background: #fff;
        width: 100%;
        height: 100vh;
        height: 100dvh;
        border-radius: 0;
        display: flex; flex-direction: column;
        overflow: hidden;
        animation: abSlide .2s ease-out;
        font-family: 'Poppins', sans-serif;
        position: relative;
      }
      @media (min-width: 640px) {
        .ab-modal {
          border-radius: 14px;
          max-width: 600px;
          height: auto;
          max-height: 82vh;
          max-height: 82dvh;
        }
      }
      @keyframes abSlide {
        from { transform: translateY(18px); opacity: 0; }
        to   { transform: translateY(0);    opacity: 1; }
      }
      @media (prefers-reduced-motion: reduce) {
        .ab-modal { animation: none; }
        .ab-pip, .ab-slot, .ab-card, .ab-step-btn, .ab-fbtn,
        .ab-open-btn, .ab-close, .ab-confirm { transition: none; }
      }

      /* ── Header ── */
      .ab-hdr {
        padding: 16px 56px 10px 16px;
        flex-shrink: 0;
        border-bottom: 1px solid #f0f0f0;
      }
      @media (min-width: 640px) {
        .ab-hdr { padding: 14px 16px 10px; }
      }

      .ab-hdr-top {
        display: flex; align-items: center;
        justify-content: space-between; margin-bottom: 10px;
      }
      .ab-title { font-size: 15px; font-weight: 700; color: #111; margin: 0; }

      /* Close button */
      .ab-close {
        position: absolute;
        top: 12px; right: 12px;
        background: #111; border: none; border-radius: 50%;
        width: 38px; height: 38px;
        cursor: pointer; font-size: 17px;
        display: flex; align-items: center; justify-content: center;
        color: #fff; flex-shrink: 0;
        transition: background .12s;
        -webkit-tap-highlight-color: transparent;
        z-index: 10;
      }
      .ab-close:active { background: #444; }
      @media (hover: hover) { .ab-close:hover { background: #333; } }
      @media (min-width: 640px) {
        .ab-close {
          position: absolute;
          top: 12px; right: 12px;
          background: #111; color: #fff;
          width: 38px; height: 38px; font-size: 17px;
        }
        .ab-close:hover { background: #333; }
      }

      /* Progress bar */
      .ab-prog { display: flex; gap: 4px; margin-bottom: 10px; }
      .ab-pip { flex: 1; height: 3px; border-radius: 2px; background: #eee; transition: background .2s; }
      .ab-pip.done { background: #f4a623; }

      /* Search + filters */
      .ab-search-row { display: flex; gap: 6px; }
      .ab-search {
        flex: 1; border: 1.5px solid #e8e8e8; border-radius: 7px;
        padding: 7px 10px 7px 30px; font-family: 'Poppins', sans-serif;
        outline: none; min-width: 0; color: #111;
        background: #fafafa url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' viewBox='0 0 24 24'%3E%3Ccircle cx='11' cy='11' r='7' stroke='%23aaa' stroke-width='2'/%3E%3Cpath d='m16 16 4 4' stroke='%23aaa' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat 9px center;
        transition: border-color .15s;
        font-size: max(13px, 16px);
      }
      .ab-search:focus { border-color: #f4a623; background-color: #fff; outline: none; }
      .ab-search::placeholder { color: #767676; }
      .ab-filter-rows { display: flex; flex-direction: column; gap: 5px; }
      .ab-filters { display: flex; gap: 4px; flex-wrap: wrap; }
      .ab-fbtn {
        padding: 6px 9px; border: 1.5px solid #e8e8e8; border-radius: 6px;
        background: #fff; font-family: 'Poppins', sans-serif; font-size: 11px;
        font-weight: 500; cursor: pointer; color: #666;
        transition: all .12s; white-space: nowrap;
        -webkit-tap-highlight-color: transparent;
      }
      .ab-fbtn.active { background: #111; border-color: #111; color: #fff; }

      /* ── Scrollable grid ── */
      .ab-body {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 10px 14px 6px;
        overscroll-behavior: contain;
      }
      .ab-nores { text-align: center; padding: 32px 0; color: #767676; font-size: 13px; display: none; }
      .ab-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
      @media (min-width: 520px) { .ab-grid { grid-template-columns: repeat(3, 1fr); } }

      .ab-card {
        border: 1.5px solid #ebebeb; border-radius: 8px;
        padding: 10px 9px; cursor: pointer; position: relative;
        background: #fff; transition: border-color .12s;
        min-height: 60px;
        -webkit-tap-highlight-color: transparent;
      }
      .ab-card:active { background: #fafafa; }
      @media (hover: hover) { .ab-card:hover { border-color: #f4a623; } }
      .ab-card.sel { border-color: #f4a623; background: #fffcf5; }
      .ab-card.dis { opacity: .32; pointer-events: none; }
      .ab-card.oos { opacity: .5; pointer-events: none; cursor: default; }
      .ab-oos-lbl {
        display: block; font-size: 9px; font-weight: 600; color: #999;
        text-transform: uppercase; letter-spacing: .05em; margin-top: 4px;
      }

      .ab-ck {
        position: absolute; top: 6px; right: 6px;
        width: 16px; height: 16px; border-radius: 50%;
        background: #f4a623; color: #111; font-size: 8px;
        display: none; align-items: center; justify-content: center; font-weight: 700;
      }
      .ab-card.sel .ab-ck { display: flex; }

      .ab-stepper {
        display: none;
        align-items: center; justify-content: center;
        gap: 0; margin-top: 7px;
      }
      .ab-card.sel .ab-stepper { display: flex; }
      .ab-step-btn {
        width: 26px; height: 26px; border-radius: 50%;
        border: 1.5px solid #f4a623; background: #fff;
        color: #111; font-size: 16px; line-height: 1;
        cursor: pointer; display: flex; align-items: center;
        justify-content: center; font-weight: 700; flex-shrink: 0;
        transition: background .12s, color .12s;
        -webkit-tap-highlight-color: transparent;
        padding: 0;
      }
      .ab-step-btn:active { background: #f4a623; color: #111; }
      @media (hover: hover) { .ab-step-btn:hover { background: #f4a623; color: #111; } }
      .ab-step-btn:disabled { opacity: .3; cursor: not-allowed; }
      .ab-step-count {
        min-width: 28px; text-align: center;
        font-size: 13px; font-weight: 700; color: #111;
      }

      .ab-gdr {
        font-size: 8px; font-weight: 600; letter-spacing: .05em;
        text-transform: uppercase; margin-bottom: 4px;
        padding: 1px 5px; border-radius: 3px; display: inline-block;
      }
      .ab-gdr.male   { background: #e8f0fe; color: #3b5bdb; }
      .ab-gdr.female { background: #fce4ec; color: #c2185b; }
      .ab-gdr.unisex { background: #f3e5f5; color: #7b1fa2; }
      .ab-tag {
        display: inline-block; font-size: 8px; font-weight: 700;
        letter-spacing: .04em; text-transform: uppercase;
        padding: 1px 5px; border-radius: 3px; vertical-align: middle;
        margin-left: 2px;
      }
      .ab-tag.new  { background: #e6f4ea; color: #1e6e36; }
      .ab-tag.best { background: #fff8e1; color: #7a5800; }
      .ab-cname  { font-size: 11px; font-weight: 600; color: #111; line-height: 1.3; margin-bottom: 1px; }
      .ab-cinspo { font-size: 10px; color: #6e6e6e; line-height: 1.3; }

      /* ── Footer ── */
      .ab-footer {
        padding: 10px 14px;
        padding-bottom: max(10px, env(safe-area-inset-bottom));
        border-top: 1px solid #f0f0f0;
        flex-shrink: 0; background: #fff;
      }
      .ab-confirm {
        width: 100%; padding: 13px; background: #f4a623;
        border: none; border-radius: 8px; font-family: 'Poppins', sans-serif;
        font-size: 14px; font-weight: 700; cursor: pointer; color: #111;
        transition: background .15s, opacity .15s;
        -webkit-tap-highlight-color: transparent;
      }
      .ab-confirm:disabled { opacity: .38; cursor: not-allowed; }
      .ab-confirm:active { background: #d9920f; }
      @media (hover: hover) { .ab-confirm:not(:disabled):hover { background: #e09510; } }
      .ab-hint {
        text-align: center; font-size: 11px;
        margin: 6px 0 0; line-height: 1.4; color: #767676;
      }

      /* ── Focus styles ── */
      .ab-slot:focus-visible,
      .ab-open-btn:focus-visible,
      .ab-close:focus-visible,
      .ab-fbtn:focus-visible,
      .ab-card:focus-visible,
      .ab-step-btn:focus-visible,
      .ab-confirm:focus-visible {
        outline: 3px solid #f4a623;
        outline-offset: 2px;
      }
      .ab-search:focus-visible {
        outline: 3px solid #f4a623;
        outline-offset: 2px;
        border-color: #f4a623;
      }
      .ab-slot:focus:not(:focus-visible),
      .ab-open-btn:focus:not(:focus-visible),
      .ab-close:focus:not(:focus-visible),
      .ab-fbtn:focus:not(:focus-visible),
      .ab-card:focus:not(:focus-visible),
      .ab-step-btn:focus:not(:focus-visible),
      .ab-confirm:focus:not(:focus-visible),
      .ab-search:focus:not(:focus-visible) { outline: none; }
    `;
    document.head.appendChild(s);
  }

  function hideNativeUI(container) {
    container.querySelectorAll('label, select').forEach(el => el.style.display = 'none');
  }

  function parseFragrances() {
    const sel = document.getElementById('fragrance-1');
    if (!sel) return [];
    return Array.from(sel.querySelectorAll('option[value]:not([value=""])')).map(opt => {
      const val = opt.value.trim();
      const gm = val.match(/- (Male|Female|Unisex) -?/i);
      const im = val.match(/Smells Like (.+?)(?:\s*-\s*(?:Male|Female|Unisex)|$)/i);
      const nm = val.match(/^(.+?) - Smells Like/i);
      const name = nm ? nm[1].trim() : val;
      return {
        value:    val,
        name,
        inspo:    im ? im[1].trim() : '',
        gender:   gm ? gm[1].toLowerCase() : 'unisex',
        isNew:    NEW_FRAGRANCES.includes(name),
        isBest:   BESTSELLER_FRAGRANCES.includes(name),
        outOfStock: opt.disabled,
      };
    });
  }

  function shortName(val) {
    if (!val) return '';
    const nm = val.match(/^(.+?) - Smells Like (.+?)(?:\s*-\s*(?:Male|Female|Unisex)|$)/i);
    if (nm) return `${nm[1].trim()} - Smells Like ${nm[2].trim()}`;
    const m = val.match(/^(.+?) - Smells Like/i);
    return m ? m[1].trim() : val;
  }

  function buildUI(container, N) {
    const frags = parseFragrances();
    const sel   = {};
    for (let i = 1; i <= N; i++) sel[i] = null;

    let genderFilter = 'all', catFilter = 'all', query = '', focusSlot = null;
    const slots   = () => Array.from({ length: N }, (_, i) => i + 1);
    const filled  = () => slots().filter(i => sel[i]);
    const allDone = () => filled().length === N;

    // ── Trigger UI ──────────────────────────────────────────────────────────
    const wrap = document.createElement('div');
    wrap.className = 'ab-wrap';
    container.parentNode.insertBefore(wrap, container);

    wrap.innerHTML = `
      <div class="ab-slots">
        ${slots().map(i => `
          <div class="ab-slot" id="ab-sl-${i}" role="button" tabindex="0" aria-label="Fragrance slot ${i}">
            <span class="ab-slot-num">${i}</span>
            <span class="ab-slot-lbl" id="ab-sl-${i}-lbl">Choose Fragrance ${i}</span>
            <button class="ab-slot-x" id="ab-sl-${i}-x" type="button" aria-label="Clear slot ${i}">×</button>
          </div>`).join('')}
      </div>
      <button class="ab-open-btn" id="ab-open-btn">
        Choose Your Fragrances
        <span class="ab-badge" id="ab-badge">0 / ${N}</span>
      </button>`;

    // ── Modal ───────────────────────────────────────────────────────────────
    const overlay = document.createElement('div');
    overlay.className = 'ab-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'ab-modal-title');
    overlay.innerHTML = `
      <div class="ab-modal" id="ab-modal">
        <button class="ab-close" id="ab-close" aria-label="Close">✕</button>
        <div class="ab-hdr">
          <div class="ab-hdr-top">
            <p class="ab-title" id="ab-modal-title">Choose Your ${N} Fragrances</p>
          </div>
          <div class="ab-prog" role="progressbar" aria-valuemin="0" aria-valuemax="${N}" aria-valuenow="0" id="ab-prog">
            ${slots().map(i => `<div class="ab-pip" id="ab-pip-${i}"></div>`).join('')}
          </div>
          <div class="ab-search-row">
            <label for="ab-search" class="ab-sr-only">Search fragrances</label>
            <input class="ab-search" id="ab-search" type="search"
              placeholder="Search…" autocomplete="off" autocorrect="off" autocapitalize="off" aria-label="Search fragrances">
            <div class="ab-filter-rows">
              <div class="ab-filters" id="ab-gender-filters" role="radiogroup" aria-label="Filter by gender">
                <button class="ab-fbtn active" data-group="gender" data-f="all" role="radio" aria-checked="true">All</button>
                <button class="ab-fbtn" data-group="gender" data-f="male" role="radio" aria-checked="false">Him</button>
                <button class="ab-fbtn" data-group="gender" data-f="female" role="radio" aria-checked="false">Her</button>
                <button class="ab-fbtn" data-group="gender" data-f="unisex" role="radio" aria-checked="false">Both</button>
              </div>
              <div class="ab-filters" id="ab-cat-filters" role="radiogroup" aria-label="Filter by category">
                <button class="ab-fbtn active" data-group="cat" data-f="all" role="radio" aria-checked="true">All</button>
                <button class="ab-fbtn" data-group="cat" data-f="best" role="radio" aria-checked="false">⭐ Best Sellers</button>
                <button class="ab-fbtn" data-group="cat" data-f="new" role="radio" aria-checked="false">✨ New</button>
              </div>
            </div>
          </div>
        </div>
        <div class="ab-body" id="ab-body">
          <div class="ab-nores" id="ab-nores">No results.</div>
          <div class="ab-grid" id="ab-grid" role="listbox" aria-label="Fragrances" aria-multiselectable="true"></div>
        </div>
        <div class="ab-footer">
          <button class="ab-confirm" id="ab-confirm" disabled>Confirm</button>
          <p class="ab-hint" id="ab-hint" aria-live="polite" aria-atomic="true">Select all ${N} fragrances to continue</p>
        </div>
      </div>`;
    document.body.appendChild(overlay);

    // ── Render grid ─────────────────────────────────────────────────────────
    function renderGrid() {
      const grid  = document.getElementById('ab-grid');
      const nores = document.getElementById('ab-nores');
      const q = query.toLowerCase();
      const n = filled().length;

      const visible = frags.filter(f => {
        const gok = genderFilter === 'all' || f.gender === genderFilter;
        const cok = catFilter === 'all'
                 || (catFilter === 'new'  && f.isNew)
                 || (catFilter === 'best' && f.isBest);
        const sok = !q || f.name.toLowerCase().includes(q) || f.inspo.toLowerCase().includes(q);
        return gok && cok && sok;
      });

      nores.style.display = visible.length ? 'none' : 'block';
      grid.innerHTML = '';

      visible.forEach(f => {
        const filledSlots = slots().filter(i => sel[i] === f.value);
        const isSel = filledSlots.length > 0;
        const isOos = f.outOfStock;
        const isDis = !isOos && n >= N && !isSel;
        const badge = filledSlots.length === 1 ? filledSlots[0]
                    : filledSlots.length  > 1  ? `×${filledSlots.length}` : '';
        const gLbl = f.gender === 'male' ? 'For Him' : f.gender === 'female' ? 'For Her' : 'Unisex';

        const card = document.createElement('div');
        card.className = 'ab-card' + (isSel ? ' sel' : '') + (isDis ? ' dis' : '') + (isOos ? ' oos' : '');
        card.setAttribute('tabindex', (isDis || isOos) ? '-1' : '0');
        card.setAttribute('role', 'option');
        card.setAttribute('aria-selected', isSel ? 'true' : 'false');
        card.setAttribute('aria-disabled', isOos ? 'true' : 'false');
        card.setAttribute('aria-label', `${f.name}, inspired by ${f.inspo}, ${gLbl}${isOos ? ', out of stock' : ''}${isSel ? `, selected ${filledSlots.length} time${filledSlots.length > 1 ? 's' : ''}` : ''}`);
        card.innerHTML = `
          <div class="ab-ck">${badge}</div>
          <span class="ab-gdr ${f.gender}">${gLbl}</span>${f.isNew ? ' <span class="ab-tag new">New</span>' : ''}${f.isBest ? ' <span class="ab-tag best">Best Seller</span>' : ''}
          <div class="ab-cname">${f.name}</div>
          <div class="ab-cinspo">Inspired by ${f.inspo}</div>
          ${isOos ? '<span class="ab-oos-lbl">Out of Stock</span>' : `
          <div class="ab-stepper">
            <button class="ab-step-btn ab-step-minus" aria-label="Remove one">−</button>
            <span class="ab-step-count">${filledSlots.length || ''}</span>
            <button class="ab-step-btn ab-step-plus" aria-label="Add one">+</button>
          </div>`}`;
        card.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
        });
        card.addEventListener('click', e => {
          if (e.target.closest('.ab-stepper')) return;
          if (!isDis && !isOos) pick(f.value);
        });
        const minusBtn = card.querySelector('.ab-step-minus');
        const plusBtn  = card.querySelector('.ab-step-plus');
        if (minusBtn) {
          minusBtn.disabled = !isSel;
          minusBtn.addEventListener('click', e => { e.stopPropagation(); deselect(f.value); });
        }
        if (plusBtn) {
          plusBtn.disabled = isDis;
          plusBtn.addEventListener('click', e => { e.stopPropagation(); pick(f.value); });
        }
        grid.appendChild(card);
      });
    }

    // ── Update trigger UI ───────────────────────────────────────────────────
    function updateTrigger() {
      const n = filled().length;
      document.getElementById('ab-badge').textContent = `${n} / ${N}`;
      slots().forEach(i => {
        const slot = document.getElementById(`ab-sl-${i}`);
        const lbl  = document.getElementById(`ab-sl-${i}-lbl`);
        if (sel[i]) {
          slot.classList.add('filled');
          lbl.textContent = shortName(sel[i]);
        } else {
          slot.classList.remove('filled');
          lbl.textContent = `Choose Fragrance ${i}`;
        }
      });
    }

    // ── Update modal state ──────────────────────────────────────────────────
    function updateModal() {
      const n = filled().length;
      slots().forEach(i => {
        document.getElementById(`ab-pip-${i}`).classList.toggle('done', !!sel[i]);
      });
      const rem = N - n;
      const progEl = document.getElementById('ab-prog');
      if (progEl) progEl.setAttribute('aria-valuenow', n);
      document.getElementById('ab-confirm').disabled = !allDone();
      document.getElementById('ab-hint').textContent = allDone()
        ? `✓ All ${N} chosen — tap Confirm`
        : `${rem} more to choose`;
      renderGrid();
    }

    function update() { updateTrigger(); updateModal(); }

    // ── Pick ────────────────────────────────────────────────────────────────
    function pick(value) {
      let target = null;
      if (focusSlot && !sel[focusSlot]) { target = focusSlot; focusSlot = null; }
      else { for (let i = 1; i <= N; i++) { if (!sel[i]) { target = i; break; } } }
      if (!target) return;
      sel[target] = value;
      update();
    }

    // ── Deselect ────────────────────────────────────────────────────────────
    function deselect(value) {
      const matching = slots().filter(i => sel[i] === value);
      if (!matching.length) return;
      sel[matching[matching.length - 1]] = null;
      update();
    }

    function clearSlot(i) { sel[i] = null; update(); }

    // ── Open / close ────────────────────────────────────────────────────────
    let _lastFocus = null;

    function getFocusable() {
      return Array.from(overlay.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(el => !el.closest('.ab-card.dis'));
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      const focusable = getFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    }

    function open(slot) {
      focusSlot = slot || null;
      _lastFocus = document.activeElement;
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      document.getElementById('ab-search').value = '';
      query = '';
      updateModal();
      overlay.addEventListener('keydown', trapFocus);
      setTimeout(() => { const s = document.getElementById('ab-search'); if (s) s.focus(); }, 50);
    }

    function close() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      overlay.removeEventListener('keydown', trapFocus);
      if (_lastFocus) { _lastFocus.focus(); _lastFocus = null; }
    }

    // ── Confirm ─────────────────────────────────────────────────────────────
    function confirm() {
      if (!allDone()) return;

      slots().forEach(i => {
        const s = document.getElementById(`fragrance-${i}`);
        if (!s) return;
        s.value = sel[i];
        s.removeAttribute('required');
        s.setCustomValidity('');
        ['input', 'change'].forEach(ev =>
          s.dispatchEvent(new Event(ev, { bubbles: true, cancelable: true }))
        );
      });

      const sbEl = document.getElementById('simple-bundles-io-options');
      if (sbEl) {
        sbEl.dispatchEvent(new Event('change', { bubbles: true }));
        sbEl.dispatchEvent(new CustomEvent('sb:validate', { bubbles: true }));
      }

      const form = document.querySelector('form[action="/cart/add"]');
      if (form) form.dispatchEvent(new Event('change', { bubbles: true }));

      setTimeout(() => {
        const btn = form
          ? form.querySelector('[name="add"], button[type="submit"], .product-form__submit')
          : document.querySelector('[name="add"], .product-form__submit');
        if (btn && btn.disabled) {
          const ok = slots().every(i => {
            const s = document.getElementById(`fragrance-${i}`);
            return s && s.value;
          });
          if (ok) {
            btn.disabled = false;
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            if (btn.textContent.toLowerCase().includes('choose')) btn.textContent = 'Add to Cart';
          }
        }
      }, 80);

      close();
    }

    // ── Events ──────────────────────────────────────────────────────────────
    slots().forEach(i => {
      const slotEl = document.getElementById(`ab-sl-${i}`);
      slotEl.addEventListener('click', () => open(i));
      slotEl.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); } });
      document.getElementById(`ab-sl-${i}-x`).addEventListener('click', e => {
        e.stopPropagation(); clearSlot(i);
      });
    });

    document.getElementById('ab-open-btn').addEventListener('click', () => open());
    document.getElementById('ab-close').addEventListener('click', close);
    overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
    document.getElementById('ab-confirm').addEventListener('click', confirm);

    document.getElementById('ab-search').addEventListener('input', e => {
      query = e.target.value;
      renderGrid();
    });

    overlay.querySelectorAll('.ab-fbtn').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.dataset.group;
        const val   = btn.dataset.f;
        if (group === 'gender') genderFilter = val;
        else                    catFilter    = val;
        overlay.querySelectorAll(`.ab-fbtn[data-group="${group}"]`).forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-checked', 'true');
        renderGrid();
      });
    });

    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
